import {
  BODY_MEASUREMENT_CATALOG,
  type BodyMeasurementTypeKey,
} from "@/lib/body-measurements";
import type { BodyMeasurementLogConfig } from "@/lib/schema";
import type { WidgetSettingsEditorProps } from "@/widgets/types";

type Props = WidgetSettingsEditorProps<BodyMeasurementLogConfig>;

export function SettingsEditor({ config, onChange, errors = {} }: Props) {
  const toggleType = (key: BodyMeasurementTypeKey) => {
    const selected = new Set(config.types);
    if (selected.has(key)) {
      selected.delete(key);
    } else {
      selected.add(key);
    }
    onChange({
      types: BODY_MEASUREMENT_CATALOG.filter((t) => selected.has(t.key)).map(
        (t) => t.key,
      ),
    });
  };

  return (
    <div
      className="widget-settings"
      data-testid={`widget-settings-${config.id}`}
    >
      <div className="setting-row">
        <label className="setting-label" htmlFor={`label-${config.id}`}>
          Tittel
        </label>
        <div className="setting-control">
          <input
            id={`label-${config.id}`}
            className="input"
            type="text"
            value={config.label}
            onChange={(e) => onChange({ label: e.target.value })}
            data-testid="widget-label-input"
          />
          {errors.label ? (
            <p className="field-error" data-testid="widget-error-label">
              {errors.label}
            </p>
          ) : null}
        </div>
      </div>
      <div className="setting-row">
        <span className="setting-label">Målinger</span>
        <div className="setting-control">
          {BODY_MEASUREMENT_CATALOG.map((t) => (
            <label className="check-option" key={t.key}>
              <input
                type="checkbox"
                checked={config.types.includes(t.key)}
                onChange={() => toggleType(t.key)}
                data-testid={`body-measurement-type-toggle-${t.key}`}
              />
              {t.label} ({t.unit})
            </label>
          ))}
          {errors.types ? (
            <p className="field-error" data-testid="widget-error-types">
              {errors.types}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
